export default __webpack_public_path__ + "static/media/ProductoSinImagen.ecdbc3fb.png";